import { Flex, Grid, Typography } from '@percent/lemonade'
import styles from './TitleCard.module.scss'
import { TitleCardProps } from './TitleCard.types'

export function TitleCard({ title, description, children, size = 6 }: TitleCardProps) {
  return (
    <Grid.Col span={{ xs: 12, sm: size }}>
      <div className={styles.titleCardContainer}>
        <Grid>
          <Grid.Col span={12}>
            <Flex direction="column" gap={8} mb={20}>
              <Typography variant="h2" className={styles.title} style={{ display: 'inline-block' }}>
                {title}
              </Typography>
              {description && <Typography className={styles.description}>{description}</Typography>}
            </Flex>
          </Grid.Col>
        </Grid>
        {children}
      </div>
    </Grid.Col>
  )
}
